import React from 'react';
import LandingSection from 'containers/contactPage/contactLanding';
import Footer from 'containers/footer';
import {useDataValue} from 'globals/contexts/dataContext';

const ContactPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const pageContent = content['content'][currentLanguage]['contact'];
  return <div id="contact" className="page">
    <LandingSection content={pageContent} />
    {/* <Footer /> */}
  </div>   
}

export default ContactPage;